export default __webpack_public_path__ + "static/media/ic_matic_96.17174147.svg";